(function () {
    'use strict';

    angular
        .module('app.community')
        .controller('TopicsListController', TopicsListController);

    TopicsListController.$inject = ['$state', 'common', 'dataservice', 'bootstrap.dialog', 'config'];
    /* @ngInject */
    function TopicsListController($state, common, dataservice, bsDialog, config) {
        var vm = this;

        vm.title = 'Community Topics';
        vm.displayedItems = [];
        vm.items = [];
        vm.navigateToTopic = navigateToTopic;
        vm.timeToAgo = timeToAgo;

        activate();

        function activate() {
            var promises = [getItems()];
            return common.$q.all(promises).then(function (data) {
                common.logger.info('Activated ' + vm.title + ' View');
            }, function (error) { });
        }

        function getItems() {
            return dataservice.getItems('api/Community/Topics').then(function (response) {
                vm.items = response.data;

                vm.displayedItems = [].concat(vm.items);
                return vm.items;
            }, function (error) { });
        }

        function navigateToTopic(topicUId) {
            var dto = {
                Data: topicUId
            };
            
            return dataservice.saveItem('api/Community/TopicViewed', dto).then(function (response) {
                $state.go('community.topicdisplay', { 'id': topicUId });
            }, function (error) { });
        }

        function timeToAgo(d) {
            var x = moment.utc(d).toDate();
            return moment(x).fromNow();
        }
    }
})();
